// Mock data for Turkish Menkul Değerler clone

export const services = [
  {
    id: 1,
    title: 'YURT İÇİ SATIŞ',
    description: 'Türkiye piyasalarına odaklı çözümler sunuyoruz.',
    icon: 'TrendingUp',
    image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=600&h=400&fit=crop',
    link: '/urun-ve-hizmetler/yurt-ici-satis',
    subServices: [
      { name: 'Pay (Hisse Senedi)', link: '/urun-ve-hizmetler/yurt-ici-satis/pay' },
      { name: 'Vadeli İşlem ve Opsiyon Sözleşmeleri (VİOP)', link: '/urun-ve-hizmetler/yurt-ici-satis/viop' },
      { name: 'Varant ve Sertifika', link: '/urun-ve-hizmetler/yurt-ici-satis/varant' },
      { name: 'Yatırım Fonları', link: '/urun-ve-hizmetler/yurt-ici-satis/yatirim-fonlari' },
      { name: 'Borsa Yatırım Fonları', link: '/urun-ve-hizmetler/yurt-ici-satis/borsa-yatirim-fonlari' },
      { name: 'Sertifikalar', link: '/urun-ve-hizmetler/yurt-ici-satis/sertifikalar' }
    ]
  },
  {
    id: 2,
    title: 'VARLIK YÖNETİMİ',
    description: 'Finansal varlıklarınızı güvenle yönlendiriyoruz.',
    icon: 'PieChart',
    image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=600&h=400&fit=crop',
    link: '/urun-ve-hizmetler/varlik-yonetimi'
  },
  {
    id: 3,
    title: 'KURUMSAL FİNANSMAN',
    description: 'Şirket finansmanı için güvenilir çözümler.',
    icon: 'Building2',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=400&fit=crop',
    link: '/urun-ve-hizmetler/kurumsal-finansman'
  }
];

export const aboutMenuItems = [
  { name: 'Bizi Tanıyın', link: '/hakkimizda/bizi-taniyin' },
  { name: 'Grubumuzun Tarihçesi', link: '/hakkimizda/tarihce' },
  { name: 'Misyon & Vizyon', link: '/hakkimizda/misyon-vizyon' },
  { name: 'Kurumsal Değerlerimiz', link: '/hakkimizda/kurumsal-degerlerimiz' },
  { name: 'Kurumsal Yönetim', link: '/hakkimizda/kurumsal-yonetim' },
  { name: 'Raporlar', link: '/hakkimizda/rapor' },
  { name: 'İştiraklerimiz ve Grup Şirketlerimiz', link: '/hakkimizda/istiraklerimiz' },
  { name: 'Bizden Haberler', link: '/hakkimizda/haberler' }
];

export const companyStats = [
  { value: '3', label: 'Ülke' },
  { value: '4', label: 'Şube' },
  { value: '350', label: 'Milyon USD Aktif Büyüklük' },
  { value: '142', label: 'Milyon TL Özkaynak' }
];

export const groupCompanies = [
  { name: 'Türk Bankası', logo: 'TB', link: '#' },
  { name: 'Türk Sigorta', logo: 'TS', link: '#' },
  { name: 'TurkishBank UK', logo: 'UK', link: '#' },
  { name: 'Turkish Menkul Değerler', logo: 'TMD', link: '#' },
  { name: 'Turkish Digital Teknolojiler', logo: 'TDT', link: '#' },
  { name: 'Allied Turkish IBU', logo: 'AT', link: '#' }
];

export const news = [
  {
    id: 1,
    title: '2025 Yılı İlk Çeyrek Finansal Sonuçları Açıklandı',
    date: '2025-04-15',
    category: 'Basın Bülteni',
    excerpt: 'Turkish Menkul Değerler 2025 yılının ilk çeyreğinde güçlü performans sergiledi.'
  },
  {
    id: 2,
    title: 'Yeni Dijital Yatırım Platformu Hizmete Girdi',
    date: '2025-03-20',
    category: 'Haberler',
    excerpt: 'Müşterilerimize daha iyi hizmet sunmak için geliştirdiğimiz yeni platform yayında.'
  },
  {
    id: 3,
    title: 'Sürdürülebilirlik Raporu Yayınlandı',
    date: '2025-02-10',
    category: 'Raporlar',
    excerpt: 'Çevresel ve sosyal sorumluluk faaliyetlerimizi detaylandıran rapor hazır.'
  }
];

export const contactInfo = {
  email: 'musterimemnuniyeti@tmdonlinesube.com',
  address: 'Büyükdere Cad. No:100-102 Esentepe/İstanbul',
  workingHours: 'Pazartesi - Cuma: 09:00 - 18:00'
};

export const navigationMenu = [
  {
    name: 'ÜRÜN & HİZMETLER',
    hasDropdown: true,
    items: [
      { name: 'Yurt İçi Satış', link: '/urun-ve-hizmetler/yurt-ici-satis' },
      { name: 'Varlık Yönetimi', link: '/urun-ve-hizmetler/varlik-yonetimi' },
      { name: 'Kurumsal Finansman', link: '/urun-ve-hizmetler/kurumsal-finansman' }
    ]
  },
  {
    name: 'HAKKIMIZDA',
    hasDropdown: true,
    items: aboutMenuItems
  },
  {
    name: 'İNTERNET ŞUBESİ',
    link: 'https://my.scuzdan.com/login',
    external: true
  },
  {
    name: 'İLETİŞİM',
    link: '/iletisim'
  },
  {
    name: 'KARİYER',
    link: '/kariyer'
  }
];